import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { consumePostAuthNotice } from "@/lib/postAuthNotice";

/** Shows a deferred sessionStorage notice after navigation (e.g. onboarding upload soft-fail). */
export function PostAuthNoticeListener() {
  const { pathname } = useLocation();
  const { toast } = useToast();

  useEffect(() => {
    const notice = consumePostAuthNotice();
    if (!notice) return;
    // Defer so the destination route/toast stack is ready after navigate.
    const id = window.setTimeout(() => {
      toast({
        variant: notice.variant,
        title: notice.title,
        description: notice.description,
      });
    }, 350);
    return () => window.clearTimeout(id);
  }, [pathname, toast]);

  return null;
}
